import { render, staticRenderFns } from "./FTPConfigurationForm.vue?vue&type=template&id=2453ad65&"
import script from "./FTPConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./FTPConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2453ad65')) {
      api.createRecord('2453ad65', component.options)
    } else {
      api.reload('2453ad65', component.options)
    }
    module.hot.accept("./FTPConfigurationForm.vue?vue&type=template&id=2453ad65&", function () {
      api.rerender('2453ad65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/FTPConfigurationForm.vue"
export default component.exports